<template>
  <label
    class="avatar"
    style="
      border-radius: 50%;
      overflow: hidden;
      position: relative;
      display: block;
    "
  >
    <input type="file" accept="image/*" @input="process" class="avatar-input" />
    <div class="person-avatar">
      <img
        :src="image_src"
        class="person-avata1r"
        style="width: 100%; position: absolute; left: 0; top: 0"
        onerror="document.querySelector('.person-avata1r').hidden=true"
      />
    </div>
  </label>
</template>
<script>
export default {
  props: {
    url: String,
    image: String,
    type: String,
  },
  methods: {
    process($event) {
      if ($event.target.files.length > 0) {
        let fd = new FormData();
        fd.append("avatar", $event.target.files[0]);
        axios
          .post(this.url, fd, { "Content-Type": "multipart/form-data" })
          .then((response) => {
            this.image_ = response.data.url;
            if (this.type == "avatar")
              this.$root.$emit("change-avatar", { avatar: this.image_ });
            else this.$root.$emit("change-logo", { logo: this.image_ });
          });
      }
    },
  },
  computed: {
    image_src() {
      if (this.image_ !== false) return this.image_;
      else return this.image;
    },
  },
  data() {
    return {
      image_: false,
    };
  },
};
</script>
<style scoped="" lang="scss">
input.avatar-input {
  position: absolute;
  top: -10100px;
}
.person-avatar {
  border-radius: 50%;
}
label {
  &:hover {
    position: relative;
    &:after {
      content: "";
      left: 10px;
      top: 10px;
      right: 10px;
      bottom: 10px;
      position: absolute;
      background-color: rgba(255, 255, 255, 0.5);
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFCSURBVFiF7da/LgRRFIDx327UOonottGIQoeCkmwp2RcgGhVCoRWN4EmIxktIFEoK0frTrUioUOxM3J3MjsjuvRuJk0wxmZPzfefck5khbmzjODKjEv6ZXSfDhCeXKIMnlVjHxzAk1jA+LIl87LeYSC1RPPNQYuMHicN+4bs9Cl+iluVUTWKvH3ivbW9jNsupkogOn8eV8p2IAn/FQgBvK9+JnZTwssWMDn/pkbeaAl7sPOrC/cNzeK8z/7vwBt5LirYxFxuexxLeJO4cDjBdkEgGr+MBz4FEU8KxLwYFQ4kkcGgVCj9hKnvWVL6YfX1YymKzAAgnsax7MQfWOUxi7BcSA4XDEW58/9VWSTQGDYe7DBRKbAUCj9iPAYYZ3d2GEi2dd0A9FnwEK8H9PS4wqtP1aSxwHjWc6XR9juvYwGJ8AXs0JTTXqU6oAAAAAElFTkSuQmCC);
      background-repeat: no-repeat;
      background-position: center;
      z-index: 2;
      border-radius: 50%;
    }
  }
}
label.avatar {
  background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_734_7654)'%3E%3Crect width='80' height='80' rx='40' fill='%23EEEEEE'/%3E%3Cpath d='M36.678 7.69673C31.2989 8.92253 26.9844 12.8971 25.042 18.3946C24.1455 20.9763 23.828 23.205 23.94 26.1581C23.9961 27.551 24.0894 28.8883 24.1642 29.0926C24.2762 29.4454 24.2202 29.4826 23.8466 29.4083C22.5392 29.1669 22.2591 31.247 23.0995 34.8316C23.4171 36.1502 23.7346 37.636 23.7906 38.1004C23.9774 39.3633 24.4817 40.0876 25.2661 40.2177C25.8638 40.3477 25.9385 40.422 26.1253 41.2763C26.5549 43.3379 28.2545 46.5324 29.4872 47.6468C29.8234 47.9625 29.8608 48.2411 29.8608 50.8784C29.8608 54.1287 29.73 54.7601 28.8709 56.0417C27.6755 57.8246 27.358 57.9175 14.732 60.8334C9.37162 62.0778 8.58716 62.3378 7.07429 63.4336C4.88903 65.0494 4.17929 66.4238 2.94657 71.2899C0.462473 81.152 -1.10643 87.7825 -0.994368 87.894C-0.826271 88.0425 5.84158 89.3426 10.3428 90.067C20.9143 91.8128 28.9082 92.5 38.4711 92.5C48.3515 92.5 56.1399 91.85 68.6165 90.0112C71.7543 89.5469 80.8876 88.024 80.9996 87.9497C81.0183 87.9311 80.3272 84.9409 79.4307 81.3378C75.77 66.4424 75.8073 66.5353 74.2944 64.7894C73.3232 63.6565 71.5675 62.505 70.1294 62.0592C69.4943 61.8735 67.0849 61.2792 64.7876 60.7591C52.9648 58.0661 52.2177 57.8061 51.0223 56.0417C50.1632 54.7601 50.0324 54.1287 50.0324 50.9527V48.1111L50.985 46.9596C52.1243 45.5666 53.2823 43.2822 53.6932 41.5549C53.8987 40.7563 54.1041 40.3105 54.2722 40.3105C54.7952 40.3105 55.5796 39.7533 55.7851 39.2519C55.8971 38.9733 56.0466 38.3975 56.1213 37.9889C56.1773 37.5803 56.4761 36.1502 56.7937 34.8316C57.6341 31.2284 57.3353 29.1669 56.0466 29.4083C55.673 29.4826 55.617 29.4454 55.729 29.0926C55.8038 28.8883 55.8971 27.5696 55.9532 26.1766C56.308 17.2989 51.5079 9.98119 43.9622 7.88246C42.4494 7.47386 38.1909 7.36242 36.678 7.69673Z' fill='white'/%3E%3C/g%3E%3Crect x='0.5' y='0.5' width='79' height='79' rx='39.5' stroke='%23EEEEEE'/%3E%3Cdefs%3E%3CclipPath id='clip0_734_7654'%3E%3Crect width='80' height='80' rx='40' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
  width: 80px;
  height: 80px;
  margin-bottom: 0;
}
</style>
